import { inject, Injectable } from '@angular/core';
import { Config } from '../../environments/config.model';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: Config | undefined;
  private http = inject(HttpClient);

  constructor() {}

  loadConfig(url: string): Promise<void> {
    return new Promise((resolve) => {
      this.http.get<Config>(url).pipe(map(res => res))
        .subscribe({
          next: (config) => {
            this.config = config;
            resolve();
          },
          error: (err) => {
            console.error('Failed to load config:', err);
            resolve(); // Always resolve so app can still boot
          }
        });
    });
  }

  get(): Config {
    return this.config!;
  }
}
